import React from "react";
import { Grid } from "@theme-ui/components";
import { InfoTile } from "../../components/molecules";
import styled from "@emotion/styled";
import { navigate } from "gatsby";

const ModulesSection = ({ data, pathName }) => {
  pathName = pathName == "/hr-garden/" ? "" : "/hr-garden/";

  const handleClick = (path) => {
    navigate(`${pathName}${path}/`, "_");
  };

  return (
    <StyledResources>
      {data.map((module, index) => (
        <InfoTile
          key={"module-" + index}
          index={index}
          title={module?.title}
          content={module?.desc}
          buttonLabel={"See More"}
          btnVariant="outlined"
          iconName={module?.icon}
          theme={module?.theme}
          onBtnClick={() => handleClick(module?.path)}
          customStyles={{
            " @media (max-width: 900px)": {
              maxWidth: "100%",
            },
          }}
          hideHoverBgColor
        />
      ))}
    </StyledResources>
  );
};

const StyledResources = styled(Grid)`
  grid-template-columns: auto auto auto;
  grid-gap: 1.5rem;
  justify-content: center;
  padding: 7rem 2rem;
  @media (max-width: 900px) {
    grid-template-columns: auto;
  }
  @media (max-width: 600px) {
    grid-template-columns: auto;
    padding: 4rem 2rem;
  }
`;

export default ModulesSection;
